var CURRENT_PROVIDER_ID = '';
var CURRENT_EMPLOYEE_ID = '';
var CURRENT_CONTACT = '';
var TOKEN = '';
var CORE_BASE_URL = '';
var setCurrentProviderId = function setCurrentProviderId(providerId) {
  CURRENT_PROVIDER_ID = providerId;
};
var setCurrentEmployeeId = function setCurrentEmployeeId(employeeId) {
  CURRENT_EMPLOYEE_ID = employeeId;
};
var setCurrentContact = function setCurrentContact(contact) {
  CURRENT_CONTACT = contact;
};
var setToken = function setToken(token) {
  return TOKEN = token;
};
var setCoreBaseUrl = function setCoreBaseUrl(coreUrl) {
  CORE_BASE_URL = coreUrl;
};
var appUtils = {
  get CURRENT_PROVIDER_ID() {
    return CURRENT_PROVIDER_ID;
  },
  setCurrentProviderId: setCurrentProviderId,
  get CURRENT_EMPLOYEE_ID() {
    return CURRENT_EMPLOYEE_ID;
  },
  setCurrentEmployeeId: setCurrentEmployeeId,
  get CURRENT_CONTACT() {
    return CURRENT_CONTACT;
  },
  setCurrentContact: setCurrentContact,
  get TOKEN() {
    return TOKEN;
  },
  setToken: setToken,
  get CORE_BASE_URL() {
    return CORE_BASE_URL;
  },
  setCoreBaseUrl: setCoreBaseUrl
};
export default appUtils;
//# sourceMappingURL=appUtils.js.map